(function () {
  /* ============================================================
  
  ============================================================ */
  /* TODO: breakpointをまたいだときの処理、リファクタリング */
  const proposeRingSwiper = new Swiper(".js-proposeRingSwiper", {
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    on: {
      init: function () {
        changeProposeRingSwiperControls(this);
      },
      slideChange: function () {
        changeProposeRingSwiperControls(this);
      },
    },
  });

  function changeProposeRingSwiperControls(swiper){
    $(".js-changeProposeRingSlide").removeClass("is-selected")
    $('.js-changeProposeRingSlide[data-slide-num="' + swiper.realIndex + '"]').addClass("is-selected");
  }

  $(".js-changeProposeRingSlide").on("click", function(){
    const slideNum = $(this).data("slideNum");
    for (let i = 0, len = proposeRingSwiper.length; i < len; i=(i+1)|0) {
      proposeRingSwiper[i].slideTo(slideNum, 500);
    }
  });

  /* ============================================================
  
  ============================================================ */
  /* TODO: breakpointをまたいだときの処理、リファクタリング */
  const proposeNecklaceSwiper = new Swiper(".js-proposeNecklaceSwiper", {
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    on: {
      init: function () {
        changeNecklaceSwiperControls(this);
      },
      slideChange: function () {
        changeNecklaceSwiperControls(this);
      },
    },
  });

  function changeNecklaceSwiperControls(swiper){
    $(".js-changeNecklaceSlide").removeClass("is-selected")
    $('.js-changeNecklaceSlide[data-slide-num="' + swiper.realIndex + '"]').addClass("is-selected");
  }

  $(".js-changeNecklaceSlide").on("click", function(){
    const slideNum = $(this).data("slideNum");
    proposeNecklaceSwiper.slideTo(slideNum, 500);
  });

  /* ============================================================
  
  ============================================================ */
  const storiesSwiper = new Swiper(".js-storiesSwiper", {
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    breakpoints: {
      900: {
        effect: "slide",
        fadeEffect: {
          crossFade: false
        },
        slidesPerView: 3,
        spaceBetween: 35,
      }
    },
    on: {
      init: function () {
        changeStoriesControls(this);
      },
      slideChange: function () {
        changeStoriesControls(this);
      },
    },
  });

  function changeStoriesControls(swiper){
    $(".js-changeStoriesSlide").removeClass("is-selected")
    $('.js-changeStoriesSlide[data-slide-num="' + swiper.realIndex + '"]').addClass("is-selected");
  }

  $(".js-changeStoriesSlide").on("click", function(){
    const slideNum = $(this).data("slideNum");
    storiesSwiper.slideTo(slideNum, 500);
  });
})();
